import { Routes, Route } from "react-router-dom";
import { getRoutes } from "@/routes";
import { useTranslation } from "react-i18next";

export function Auth() {
  const { t } = useTranslation('sidebar');
  const routes = getRoutes(t);

  return (
    <div className="relative min-h-screen w-full">
      <Routes>
        {routes.map(
          ({ layout, pages }) =>
            layout === "auth" &&
            pages.map(({ path, element }) => (
              <Route exact path={path} element={element} />
            ))
        )}
      </Routes>
    </div>
  );
}

Auth.displayName = "/src/layout/Auth.jsx";

export default Auth;
